import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M12 17h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ShieldQuestion";
const ShieldQuestion = memo(themed(Icon));
export {
  ShieldQuestion
};
//# sourceMappingURL=shield-question.js.map
